<template>
  <button
    type="button"
    class="action"
    :class="buttonClass"
    @click="doIt"
  />
</template>

<script>

export default {
  name: 'ActionButton',
  props: {
    label: {
      type: String,
      default: "I'm an action!",
    },
    buttonClass: {
      type: String,
      required: true,
    },
  },
  methods: {
    doIt: function () {
      this.$emit('doIt')
    },
  },
}

</script>
